(function($) {
    'use strict';

    const authState = {
        email: '',
        nonce: '',
        step: 'email',
        isSubmitting: false,
        nonceReady: false,
        resendTimer: null,
        isLocked: false,
    };

    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const MIN_USERNAME_LENGTH = 4;
    const MIN_PASSWORD_LENGTH = 8;

    function normalizeUsername(username) {
        return username.trim().toLowerCase();
    }

    function validateUsername(username) {
        const raw = username.trim();

        if (!raw) {
            return 'Username is required. Please choose a username.';
        }

        if (!/^[a-zA-Z0-9_]+$/.test(raw)) {
            return 'Username can only contain letters, numbers, and underscores.';
        }

        const normalized = raw.toLowerCase();

        if (normalized.length < MIN_USERNAME_LENGTH) {
            return 'Username must be at least 4 characters long.';
        }

        if (normalized.length > 60) {
            return 'Username must be 60 characters or fewer.';
        }

        return null;
    }

    function validatePassword(password) {
        if (!password) {
            return 'Password is required. Please enter a secure password.';
        }

        if (password.length < MIN_PASSWORD_LENGTH) {
            return 'Password must be at least 8 characters long.';
        }

        if (!/[A-Z]/.test(password)) {
            return 'Password must include at least one uppercase letter.';
        }

        if (!/[a-z]/.test(password)) {
            return 'Password must include at least one lowercase letter.';
        }

        if (!/[0-9]/.test(password)) {
            return 'Password must include at least one number.';
        }

        if (!/[^A-Za-z0-9]/.test(password)) {
            return 'Password must include at least one special character.';
        }

        return null;
    }

    function updateSignupEmailDisplay(email) {
        const $display = $('#signup-email-display');
        const $field = $('#signup-email-field');
        const $input = $('#signup-email');

        if (email) {
            $('#signup-email-text').text(email);
            $input.val(email);
            $display.show();
            $field.hide();
        } else {
            $display.hide();
            $field.show();
            $input.prop('readonly', false);
        }
    }

    function initLoginModal() {
        const $loginModal = $('#login-modal');

        if ($loginModal.length === 0) {
            return;
        }

        const $body = $('body');
        const $closeBtn = $loginModal.find('.login-modal-close');
        const $emailForm = $('#email-form');
        const $passwordForm = $('#password-form');
        const $signupForm = $('#signup-form');
        const $otpForm = $('#otp-form');
        const $forgotPasswordForm = $('#forgot-password-form');
        const $resetPasswordForm = $('#reset-password-form');
        const $otpDigits = $('.otp-digit');
        const $resendOtp = $('.resend-otp');
        const $resendTimer = $('.resend-timer');
        const $lockoutBanner = $('#lockout-banner');
        const $loginBtn = $('#login-submit-btn');
        const $emailBtn = $('#email-continue-btn');
        const $passwordInput = $('#signin-password');
        const $passwordSubtitle = $('.login-form-step[data-step="password"] .login-form-subtitle');

        function fetchNonce() {
            authState.nonceReady = false;
            $emailBtn.prop('disabled', true);

            return $.ajax({
                url: rifeAjax.ajaxurl,
                type: 'POST',
                data: { action: 'rife_auth_get_nonce' },
                cache: false,
            }).then(function(response) {
                if (response.success && response.data && response.data.nonce) {
                    authState.nonce = response.data.nonce;
                    authState.nonceReady = true;
                    $emailBtn.prop('disabled', false);
                    return response.data.nonce;
                }

                throw new Error('nonce_failed');
            });
        }

        function getRedirectUrl(serverUrl) {
            const fallback = (typeof rifeAjax.dashboardUrl !== 'undefined')
                ? rifeAjax.dashboardUrl
                : '/dashboard/';

            const stored = sessionStorage.getItem('rife_auth_redirect');
            const candidate = serverUrl || stored || fallback;

            try {
                const target = new URL(candidate, window.location.origin);
                if (target.origin === window.location.origin) {
                    return target.href;
                }
            } catch (e) {
                /* use fallback */
            }

            return fallback;
        }

        function redirectAfterAuth(serverUrl) {
            const url = getRedirectUrl(serverUrl);
            sessionStorage.removeItem('rife_auth_redirect');
            window.location.href = url;
        }

        function setButtonLoading($btn, loading) {
            if (loading) {
                $btn.addClass('is-loading').prop('disabled', true);
                return;
            }

            $btn.removeClass('is-loading');

            if ($btn.is('#login-submit-btn') && authState.isLocked) {
                $btn.prop('disabled', true);
                return;
            }

            $btn.prop('disabled', false);
        }

        function showMessage($container, type, text, showRetry) {
            $container
                .removeClass('success error')
                .addClass(type)
                .html(text);

            if (showRetry) {
                $container.append(' <button type="button" class="auth-retry-btn">Try again</button>');
            }

            $container.show();
        }

        function clearMessages() {
            $('.form-message').removeClass('success error').hide().empty();
            if (!authState.isLocked) {
                $lockoutBanner.hide().empty();
            }
        }

        function preparePasswordStep(options) {
            const locked = options && options.locked === true;
            const $message = $passwordForm.find('.form-message');

            if (locked) {
                const msg = (options && options.message) || 'Your account has been temporarily locked due to multiple failed login attempts. Please use Forgot Password to regain access.';

                authState.isLocked = true;
                $lockoutBanner.text(msg).show();
                showMessage($message, 'error', msg);
                $passwordSubtitle.text('Account temporarily locked');
                $loginBtn.prop('disabled', true).removeClass('is-loading');
                $passwordInput.prop('disabled', true).val('');
                return;
            }

            authState.isLocked = false;
            $lockoutBanner.hide().empty();
            $message.removeClass('success error').hide().empty();
            $passwordSubtitle.text('Enter your password to sign in');
            $loginBtn.prop('disabled', false).removeClass('is-loading');
            $passwordInput.prop('disabled', false);
        }

        function clearLockoutState() {
            preparePasswordStep({ locked: false });
        }

        function resetOtpInputs() {
            $otpDigits.val('');
            $('#otp-code').val('');
        }

        function resetForms(preserveEmail) {
            $emailForm[0].reset();
            $passwordForm[0].reset();
            $signupForm[0].reset();
            $otpForm[0].reset();
            $forgotPasswordForm[0].reset();
            $resetPasswordForm[0].reset();
            resetOtpInputs();
            clearMessages();

            if (preserveEmail && authState.email) {
                $('#auth-email').val(authState.email);
                $('#password-email').val(authState.email);
                $('#signup-email').val(authState.email);
            }
        }

        function switchFormStep(step) {
            authState.step = step;
            $('.login-form-step').hide();
            const $target = $('.login-form-step[data-step="' + step + '"]');

            if ($target.length === 0) {
                return;
            }

            if (step !== 'password') {
                clearLockoutState();
            }

            $target.show();
            clearMessages();

            if (step === 'password' && authState.email) {
                $('#password-email').val(authState.email);

                if (!authState.isLocked) {
                    $loginBtn.prop('disabled', false).removeClass('is-loading');
                    $passwordInput.prop('disabled', false);

                    if (!$passwordInput.prop('disabled')) {
                        $passwordInput.focus();
                    }
                }
            }

            if (step === 'signup') {
                if (authState.email) {
                    updateSignupEmailDisplay(authState.email);
                    $('#signup-fullname').focus();
                } else {
                    updateSignupEmailDisplay('');
                    $('#signup-email').focus();
                }
            }

            if (step === 'forgot-password' && authState.email) {
                $('#forgot-email').val(authState.email);
            }
        }

        function closeLoginModal() {
            $loginModal.attr('aria-hidden', 'true').removeClass('active');
            $body.removeClass('login-modal-open');
            authState.isSubmitting = false;
            stopResendTimer();
            clearLockoutState();
            resetForms(false);
            authState.email = '';

            if (window.location.hash === '#auth') {
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }
        }

        function openLoginModal(step) {
            step = step || 'email';

            if (step === 'signin') {
                step = 'email';
            }

            switchFormStep(step);
            resetForms(true);
            $loginModal.attr('aria-hidden', 'false').addClass('active');
            $body.addClass('login-modal-open');

            fetchNonce().catch(function() {
                showMessage(
                    $emailForm.find('.form-message'),
                    'error',
                    'Please wait…',
                    true
                );
            });

            if (step === 'email') {
                $('#auth-email').focus();
            }
        }

        function submitWithGuard($btn, ajaxCall, $messageEl) {
            if ($btn.is('#login-submit-btn') && authState.isLocked) {
                if ($messageEl && $messageEl.length) {
                    showMessage(
                        $messageEl,
                        'error',
                        $lockoutBanner.text() || 'Your account is temporarily locked. Please use Forgot Password to regain access.'
                    );
                }
                return $.Deferred().reject();
            }

            if (authState.isSubmitting) {
                if ($messageEl && $messageEl.length) {
                    showMessage($messageEl, 'error', 'Please wait for the current request to finish.');
                }
                return $.Deferred().reject();
            }

            if (!authState.nonceReady || !authState.nonce) {
                return fetchNonce()
                    .then(function() {
                        return submitWithGuard($btn, ajaxCall, $messageEl);
                    })
                    .catch(function() {
                        if ($messageEl && $messageEl.length) {
                            showMessage($messageEl, 'error', 'Unable to start secure session. Please try again.', true);
                        }
                        return $.Deferred().reject();
                    });
            }

            authState.isSubmitting = true;
            setButtonLoading($btn, true);

            let request;

            try {
                request = ajaxCall();
            } catch (error) {
                authState.isSubmitting = false;
                setButtonLoading($btn, false);

                if ($messageEl && $messageEl.length) {
                    showMessage($messageEl, 'error', 'Something went wrong. Please try again.');
                }

                return $.Deferred().reject();
            }

            if (!request || typeof request.always !== 'function') {
                authState.isSubmitting = false;
                setButtonLoading($btn, false);

                if ($messageEl && $messageEl.length) {
                    showMessage($messageEl, 'error', 'Something went wrong. Please try again.');
                }

                return $.Deferred().reject();
            }

            return request.always(function() {
                authState.isSubmitting = false;
                setButtonLoading($btn, false);
            });
        }

        function handleAuthError($messageEl, $btn, response) {
            const data = response && response.data ? response.data : {};
            const msg = data.message || 'Something went wrong. Please try again.';
            const isNonce = data.code === 'invalid_nonce' || data.retry === true;

            showMessage($messageEl, 'error', msg, isNonce);

            if (isNonce) {
                authState.nonceReady = false;
                fetchNonce();
            }
        }

        function updateOtpHiddenInput() {
            let otpValue = '';
            $otpDigits.each(function() {
                otpValue += $(this).val() || '';
            });
            $('#otp-code').val(otpValue);
        }

        function startResendTimer(seconds) {
            stopResendTimer();
            $resendOtp.addClass('disabled').attr('aria-disabled', 'true');

            let remaining = seconds;

            function tick() {
                if (remaining <= 0) {
                    stopResendTimer();
                    return;
                }
                $resendTimer.text('(' + remaining + 's)');
                remaining--;
            }

            tick();
            authState.resendTimer = setInterval(tick, 1000);
        }

        function stopResendTimer() {
            if (authState.resendTimer) {
                clearInterval(authState.resendTimer);
                authState.resendTimer = null;
            }
            $resendTimer.text('');
            $resendOtp.removeClass('disabled').removeAttr('aria-disabled');
        }

        $('#open-login-modal').on('click', function(e) {
            e.preventDefault();
            openLoginModal('email');
        });

        $(document).on('click', '.rife-open-login-modal', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const redirect = $(this).data('redirect');
            if (redirect) {
                sessionStorage.setItem('rife_auth_redirect', redirect);
            }

            openLoginModal('email');
        });

        $closeBtn.on('click', closeLoginModal);

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $loginModal.hasClass('active')) {
                closeLoginModal();
            }
        });

        $loginModal.on('click', function(e) {
            if ($(e.target).hasClass('login-modal-overlay')) {
                closeLoginModal();
            }
        });

        $(document).on('click', '.back-to-email', function(e) {
            e.preventDefault();
            switchFormStep('email');
            if (authState.email) {
                $('#auth-email').val(authState.email);
            }
        });

        $('.switch-to-signup-direct').on('click', function(e) {
            e.preventDefault();
            authState.email = $('#auth-email').val().trim();
            switchFormStep('signup');
        });

        $('#signup-username').on('blur', function() {
            $(this).val(normalizeUsername($(this).val()));
        });

        $('.forgot-password-link').on('click', function(e) {
            e.preventDefault();
            switchFormStep('forgot-password');
        });

        $(document).on('click', '.password-toggle', function() {
            const targetId = $(this).data('target');
            const $input = $('#' + targetId);
            const isPassword = $input.attr('type') === 'password';

            $input.attr('type', isPassword ? 'text' : 'password');
            $(this).find('.icon-eye').toggle(!isPassword);
            $(this).find('.icon-eye-off').toggle(isPassword);
            $(this).attr('aria-label', isPassword ? 'Hide password' : 'Show password');
        });

        $(document).on('click', '.auth-retry-btn', function(e) {
            e.preventDefault();
            clearMessages();
            fetchNonce().then(function() {
                showMessage($emailForm.find('.form-message'), 'success', 'Ready. Please continue.');
                setTimeout(function() {
                    $emailForm.find('.form-message').hide();
                }, 2000);
            }).catch(function() {
                showMessage($emailForm.find('.form-message'), 'error', 'Something went wrong. Please try again.', true);
            });
        });

        $otpDigits.on('input', function() {
            const $this = $(this);
            const value = $this.val().replace(/[^0-9]/g, '');
            $this.val(value);

            if (value && $this.next('.otp-digit').length) {
                $this.next('.otp-digit').focus();
            }

            updateOtpHiddenInput();
        });

        $otpDigits.on('keydown', function(e) {
            const $this = $(this);

            if (e.key === 'Backspace' && !$this.val() && $this.prev('.otp-digit').length) {
                $this.prev('.otp-digit').focus();
            }

            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                e.preventDefault();
                navigator.clipboard.readText().then(function(text) {
                    const digits = text.replace(/[^0-9]/g, '').substring(0, 6);
                    $otpDigits.each(function(index) {
                        $(this).val(digits[index] || '');
                    });
                    updateOtpHiddenInput();

                    if (digits.length === 6) {
                        $otpForm.find('button[type="submit"]').focus();
                    } else {
                        $otpDigits.eq(digits.length).focus();
                    }
                });
            }
        });

        $emailForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');
            const email = $('#auth-email').val().trim();

            if (!email) {
                showMessage($message, 'error', 'Email address is required.');
                return;
            }

            if (!EMAIL_REGEX.test(email)) {
                showMessage($message, 'error', 'Invalid email format. Please enter a valid email address.');
                return;
            }

            authState.email = email;

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_check_email',
                        email: email,
                        nonce: authState.nonce,
                    },
                }).done(function(response) {
                    if (!response.success) {
                        handleAuthError($message, $btn, response);
                        return;
                    }

                    const data = response.data;

                    if (data.status === 'exists') {
                        switchFormStep('password');
                        preparePasswordStep({
                            locked: data.locked === true,
                            message: data.message,
                        });
                    } else {
                        authState.email = email;
                        switchFormStep('signup');
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        $passwordForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');
            const email = $('#password-email').val().trim();
            const password = $('#signin-password').val();

            if (authState.isLocked) {
                showMessage(
                    $message,
                    'error',
                    $lockoutBanner.text() || 'Your account is temporarily locked. Please use Forgot Password to regain access.'
                );
                return;
            }

            if (!password) {
                showMessage($message, 'error', 'Password is required.');
                return;
            }

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_user_login',
                        email: email,
                        password: password,
                        remember: $('#remember-me').is(':checked') ? 1 : 0,
                        nonce: authState.nonce,
                        redirect: sessionStorage.getItem('rife_auth_redirect') || '',
                    },
                }).done(function(response) {
                    if (response.success) {
                        showMessage($message, 'success', 'Login successful! Redirecting…');
                        setTimeout(function() {
                            redirectAfterAuth(response.data && response.data.redirect_url);
                        }, 800);
                    } else {
                        const data = response.data || {};

                        if (data.locked === true) {
                            preparePasswordStep({
                                locked: true,
                                message: data.message,
                            });
                        } else {
                            handleAuthError($message, $btn, response);
                        }
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        $signupForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');

            const full_name = $('#signup-fullname').val().trim();
            const email = $('#signup-email').val().trim();
            const phone_number = $('#signup-phone').val().trim();
            const username = normalizeUsername($('#signup-username').val());
            const password = $('#signup-password').val();

            if (!full_name) {
                showMessage($message, 'error', 'Full name is required.');
                return;
            }

            if (!email || !EMAIL_REGEX.test(email)) {
                showMessage($message, 'error', 'Please enter a valid email address.');
                return;
            }

            if (!phone_number || phone_number.replace(/[^0-9]/g, '').length < 10) {
                showMessage($message, 'error', 'Please enter a valid 10-digit phone number.');
                return;
            }

            const usernameError = validateUsername(username);
            if (usernameError) {
                showMessage($message, 'error', usernameError);
                $('#signup-username').focus();
                return;
            }

            const passwordError = validatePassword(password);
            if (passwordError) {
                showMessage($message, 'error', passwordError);
                $('#signup-password').focus();
                return;
            }

            $('#signup-username').val(username);

            authState.email = email;

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_user_signup',
                        full_name: full_name,
                        email: email,
                        phone_number: phone_number,
                        username: username,
                        password: password,
                        nonce: authState.nonce,
                    },
                }).done(function(response) {
                    if (response.success) {
                        showMessage($message, 'success', response.data.message || 'OTP sent successfully.');
                        startResendTimer(60);
                        setTimeout(function() {
                            switchFormStep('otp');
                            $otpDigits.first().focus();
                        }, 1200);
                    } else {
                        handleAuthError($message, $btn, response);
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        $otpForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');
            const otpCode = $('#otp-code').val();

            if (!otpCode || otpCode.length !== 6 || !/^\d{6}$/.test(otpCode)) {
                showMessage($message, 'error', 'Please enter a valid 6-digit code.');
                return;
            }

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_verify_otp',
                        otp: otpCode,
                        nonce: authState.nonce,
                        redirect: sessionStorage.getItem('rife_auth_redirect') || '',
                    },
                }).done(function(response) {
                    if (response.success) {
                        showMessage($message, 'success', 'Verified! Redirecting…');
                        setTimeout(function() {
                            redirectAfterAuth(response.data && response.data.redirect_url);
                        }, 800);
                    } else {
                        handleAuthError($message, $btn, response);
                        resetOtpInputs();
                        $otpDigits.first().focus();
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        $resendOtp.on('click', function(e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }

            const $message = $otpForm.find('.form-message');

            $.ajax({
                url: rifeAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'rife_resend_otp',
                    nonce: authState.nonce,
                },
            }).done(function(response) {
                if (response.success) {
                    showMessage($message, 'success', response.data.message);
                    startResendTimer(response.data.retry_after || 60);
                } else {
                    const retryAfter = response.data && response.data.retry_after;
                    if (retryAfter) {
                        startResendTimer(retryAfter);
                    }
                    handleAuthError($message, null, response);
                }
            }).fail(function(xhr) {
                handleAuthError($message, null, xhr.responseJSON);
            });
        });

        $forgotPasswordForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');
            const email = $('#forgot-email').val().trim();

            if (!email || !EMAIL_REGEX.test(email)) {
                showMessage($message, 'error', 'Please enter a valid email address.');
                return;
            }

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_forgot_password',
                        email: email,
                        nonce: authState.nonce,
                    },
                }).done(function(response) {
                    if (response.success) {
                        showMessage($message, 'success', response.data.message);
                        $form[0].reset();
                    } else {
                        handleAuthError($message, $btn, response);
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        $resetPasswordForm.on('submit', function(e) {
            e.preventDefault();

            const $form = $(this);
            const $btn = $form.find('button[type="submit"]');
            const $message = $form.find('.form-message');
            const token = $('#reset-token').val();
            const password = $('#reset-password').val();
            const confirmPassword = $('#reset-confirm-password').val();

            if (!token) {
                showMessage($message, 'error', 'Invalid reset session. Please request a new password reset.');
                return;
            }

            if (!password) {
                showMessage($message, 'error', 'Password is required. Please enter a new password.');
                return;
            }

            const resetPasswordError = validatePassword(password);
            if (resetPasswordError) {
                showMessage($message, 'error', resetPasswordError);
                return;
            }

            if (password !== confirmPassword) {
                showMessage($message, 'error', 'Passwords do not match.');
                return;
            }

            submitWithGuard($btn, function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_reset_password',
                        token: token,
                        password: password,
                        confirm_password: confirmPassword,
                        nonce: authState.nonce,
                    },
                }).done(function(response) {
                    if (response.success) {
                        showMessage($message, 'success', response.data.message);
                        setTimeout(function() {
                            authState.email = response.data.email || '';
                            switchFormStep('email');
                            if (authState.email) {
                                $('#auth-email').val(authState.email);
                            }
                            fetchNonce();
                        }, 2000);
                    } else {
                        handleAuthError($message, $btn, response);
                    }
                }).fail(function(xhr) {
                    handleAuthError($message, $btn, xhr.responseJSON);
                });
            }, $message);
        });

        function checkResetToken() {
            const urlParams = new URLSearchParams(window.location.search);
            const action = urlParams.get('action');
            const token = urlParams.get('token');

            if (action !== 'reset-password' || !token) {
                return false;
            }

            if (typeof rifeAjax === 'undefined' || !rifeAjax.ajaxurl) {
                setTimeout(checkResetToken, 200);
                return true;
            }

            fetchNonce().then(function() {
                return $.ajax({
                    url: rifeAjax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'rife_verify_reset_token',
                        token: token,
                        nonce: authState.nonce,
                    },
                });
            }).done(function(response) {
                if (response.success) {
                    $('#reset-token').val(token);
                    if (response.data.email) {
                        $('#reset-email').val(response.data.email);
                        authState.email = response.data.email;
                    }
                    openLoginModal('reset-password');
                    window.history.replaceState({}, document.title, window.location.pathname);
                } else {
                    openLoginModal('forgot-password');
                    setTimeout(function() {
                        showMessage(
                            $('#forgot-password-form .form-message'),
                            'error',
                            (response.data && response.data.message) || 'Invalid or expired reset link.'
                        );
                    }, 200);
                    window.history.replaceState({}, document.title, window.location.pathname);
                }
            }).fail(function() {
                openLoginModal('forgot-password');
                window.history.replaceState({}, document.title, window.location.pathname);
            });

            return true;
        }

        window.openLoginModal = openLoginModal;

        setTimeout(function() {
            const hasResetToken = checkResetToken();

            if (!hasResetToken && window.location.hash === '#auth') {
                openLoginModal('email');
            }
        }, 300);

        $(window).on('hashchange', function() {
            if (window.location.hash === '#auth') {
                openLoginModal('email');
            } else if (window.location.hash === '' && $loginModal.hasClass('active')) {
                closeLoginModal();
            }
        });
    }

    $(document).ready(initLoginModal);

})(jQuery);
